import { CUSTOMER_TYPE, GENDER, CUSTOMER_STATUS } from '@/utils/enum'

export const TABLE_FIELDS = [
  {
    key: 'index',
    label: 'STT',
    thStyle: { textAlign: 'center', width: '2%' },
    class: 'text-center',
  },
  {
    key: 'fullName',
    label: 'Khách hàng',
    thStyle: { textAlign: 'center', width: '18%' },
  },
  {
    key: 'type',
    label: 'Nhóm KH/NCC',
    thStyle: { textAlign: 'center', width: '8%' },
    class: 'text-center',
  },
  {
    key: 'phoneNo',
    label: 'Điện thoại',
    thStyle: { textAlign: 'center', width: '10%' },
  },
  {
    key: 'address',
    label: 'Địa chỉ',
    thStyle: { textAlign: 'center', width: '10%' },
  },
  {
    key: 'totalBuyedAmount',
    label: 'Tổng tiền',
    thStyle: { textAlign: 'center' },
    tdClass: 'text-right',
  },
  {
    key: 'totalBuyedNo',
    label: 'Số lần mua',
    thStyle: { textAlign: 'center' },
    tdClass: 'text-right',
  },
  {
    key: 'lastedBuyedAt',
    label: 'Ngày mua gần nhất',
    thStyle: { textAlign: 'center' },
    tdClass: 'text-right',
  },
  {
    key: 'status',
    label: 'Trạng thái',
    thStyle: { textAlign: 'center', width: '11%' },
    class: 'text-center',
  },
  {
    key: 'actions',
    label: '',
    class: 'text-center',
    thStyle: { width: '50px' },
  },
]

export const DATE_CONFIG = {
  format: 'DD/MM/YYYY',
  useCurrent: false,
  showClear: true,
  showClose: true,
  locale: 'vi',
  sideBySide: true,
}

export const BREADSCRUMB = [
  { title: 'Khách hàng', route: '/customers' },
  { title: 'Danh sách khách hàng' },
]

export const EXPORT_EXCEL_FIELDS = [
  { text: 'Khách hàng', value: 'fullName' },
  { text: 'Mã khách hàng', value: 'code' },
  { text: 'Loại', value: 'type' },
  { text: 'Điện thoại', value: 'phoneNo' },
  { text: 'Email', value: 'email' },
  { text: 'Mã số thuế', value: 'taxCode' },
  { text: 'Tổng tiền', value: 'totalBuyedAmount' },
  { text: 'Số lần mua', value: 'totalBuyedNo' },
  { text: 'Trạng thái', value: 'statusName' },
]

export const GENDER_OPTIONS = [
  { text: 'Nam', value: 1 },
  { text: 'Nữ', value: 0 },
]

export const CUSTOMER_TYPE_OPTIONS = [
  { value: null,                              text: 'Chọn Nhóm KH/NCC' },
  { value: CUSTOMER_TYPE.RETAIL_CUSTOMER,     text: 'Khách lẻ' },
  { value: CUSTOMER_TYPE.WHOLESALE_CUSTOMER,  text: 'Khách buôn' },
  { value: CUSTOMER_TYPE.AGENCY,              text: 'Đại lý' },
  { value: CUSTOMER_TYPE.VIP,                 text: 'Khách VIP' },
  { value: CUSTOMER_TYPE.KOL,                 text: 'KOL' },
  { value: CUSTOMER_TYPE.INSTALLMENT,         text: 'Trả góp' },
  { value: CUSTOMER_TYPE.CREDIT,              text: 'Tín dụng' },
  { value: CUSTOMER_TYPE.PERSONAL,            text: 'Cá nhân' },
  { value: CUSTOMER_TYPE.BUSINESS_HOUSEHOLD,  text: 'HKD' },
  { value: CUSTOMER_TYPE.COMPANY,             text: 'Công ty' },
]

export const STATUS_OPTIONS = [
  { value: null, text: 'Tất cả trạng thái' },
  { value: CUSTOMER_STATUS.ACTIVE, text: 'Đang giao dịch' },
  { value: CUSTOMER_STATUS.DEACTIVE, text: 'Ngưng giao dịch' },
]

export const MAP_CUSTOMER_STATUS = {
  [CUSTOMER_STATUS.ACTIVE]: 'Đang giao dịch',
  [CUSTOMER_STATUS.DEACTIVE]: 'Ngưng giao dịch',
}

export const MAP_CUSTOMER_TYPE = {
  [CUSTOMER_TYPE.RETAIL_CUSTOMER]: 'Khách lẻ',
  [CUSTOMER_TYPE.WHOLESALE_CUSTOMER]: 'Khách buôn',
  [CUSTOMER_TYPE.AGENCY]: 'Đại lý',
  [CUSTOMER_TYPE.VIP]: 'Khách VIP',
  [CUSTOMER_TYPE.KOL]: 'KOL',
  [CUSTOMER_TYPE.INSTALLMENT]: 'Trả góp',
  [CUSTOMER_TYPE.CREDIT]: 'Tín dụng',
  [CUSTOMER_TYPE.PERSONAL]: 'Cá nhân',
  [CUSTOMER_TYPE.BUSINESS_HOUSEHOLD]: 'Hộ KD',
  [CUSTOMER_TYPE.COMPANY]: 'Công ty',
}

export const MAP_CUSTOMER_GENDER = {
  [GENDER.MALE]: 'Nam',
  [GENDER.FEMALE]: 'Nữ',
}
